import{useRef as r,useEffect as t}from"react";const c=(c,e)=>{const o=r(!1);t(()=>{o.current&&c(),o.current=!0},e)};export{c as default};
